import { getVenuaPlannerPersonSuggestions } from '@/api/generated/venua-planner-planning/venua-planner-planning';
import type { ListRequest, PersonSuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';
import { createAsyncSelectorField } from '@/shared/forms';
import type { PersonRef } from '../plannerApi';

const personSelector = defineEntityAsyncSelector<
  PersonRef,
  PersonSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getVenuaPlannerPersonSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('venua-planner.persons', request),
    mapItem: (s) => ({
      partyId: s.partyId,
      fullName: s.fullName,
    }),
  },
  key: (item) => item.partyId,
  objectCategory: 'Person',
  // Tři tečky (⋯) otevřou list page dané ObjectCategory v Magic desktopu přes `form/list`,
  // ne interní React pick modal.
  listPicker: 'legacy',
  display: { kind: 'firstColumn' },
  columns: (t) => [
    selectorPresets.textColumn({
      id: 'prijmeni',
      header: t('personSelector.columns.name'),
      value: (item) => item.fullName,
      sortable: true,
    }),
  ],
  i18n: { namespace: 'planner' },
});

export const PersonSelector = personSelector.Selector;
export const PersonSelectorField = createAsyncSelectorField(PersonSelector);
